import { Instagram, Facebook, Youtube, Linkedin, Pin } from "lucide-react";

export const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/bon_evento" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/bonevento" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@bonevento" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/bon-evento" },
  { icon: Pin, label: "Pinterest", href: "https://in.pinterest.com/bon_evento" },
];

const SocialIcons = ({ size = "default", className = "" }) => {
  const isCompact = size === "compact";
  return (
    <div
      data-testid="social-row"
      className={`flex flex-wrap gap-2.5 ${className}`}
    >
      {SOCIALS.map(({ icon: Icon, label, href }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`social-${label.toLowerCase()}`}
          aria-label={`Bon Evento on ${label}`}
          className={`inline-flex items-center justify-center border border-[#F0EBE1]/15 text-[#F0EBE1]/65 hover:border-[#B8935C] hover:text-[#B8935C] transition-colors ${
            isCompact ? "w-8 h-8" : "w-9 h-9"
          }`}
        >
          <Icon size={isCompact ? 13 : 15} strokeWidth={1.4} />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
